import { normalizeColor } from './normalizeColor'

/**
 * Option axis names that are almost always color in e-commerce.
 */
const COLOR_OPTION_NAME_RE =
  /\b(color|colour|couleur|teinte|nuance|farbe|colorway|لون|色调|顏色|颜色|色|색상|tinta|tinte|tönung|teint)\b/i

/** Heuristic: value looks like a color token (not a pure size / SKU). */
const NON_COLOR_RE =
  /^(xxs|xs|s|m|l|xl|xxl|xxxl|2xl|3xl|4xl|5xl|\d{2,4}\s*(cm|mm|in|"|')?|one[\s-]?size|os|std|pack\s*of|\d+\s*pcs?)$/i

function valueLooksColorish(val: string): boolean {
  const t = String(val ?? '').trim()
  if (!t || t.length > 80) return false
  if (NON_COLOR_RE.test(t)) return false
  const n = normalizeColor(t)
  /** Strict: seulement si une teinte fiable existe (pas d’invention HSL). */
  return n.hex != null
}

/**
 * Whether an option axis should use color swatch UI.
 * Uses option name first; if ambiguous, infers from value distribution.
 */
export function detectColorOption(optionName: string, values?: readonly string[]): boolean {
  const name = String(optionName ?? '').trim()
  if (!name) return false
  if (COLOR_OPTION_NAME_RE.test(name)) return true
  /** Arabic “color” — `\b` word boundaries are unreliable with Arabic script. */
  if (/^(لون|اللون)$/u.test(name)) return true

  if (values && values.length >= 2) {
    const sample = values.filter(Boolean)
    if (sample.length < 2) return false
    let hits = 0
    for (const v of sample) {
      if (valueLooksColorish(v)) hits += 1
    }
    if (hits / sample.length >= 0.5) return true
  }

  return false
}
